import {
  GRAPH_CONTRACT_COLOR,
  GRAPH_MONTH_COLOR,
  GRAPH_QUARTER_COLOR,
  GRAPH_RELEASED_COLOR, GRAPH_RELEASING_COLOR,
  GRAPH_TRADING_COLOR,
  GRAPH_YEAR_COLOR,
} from '../../../constants/colors';

export const graphColumns = {
  CONTRACT: 'CONTRACT',
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  ANNUAL: 'ANNUAL',
  TRADING: 'TRADING',
  RELEASING: 'RELEASING',
  RELEASE: 'RELEASE',
};

export const graphConfig = {
  [graphColumns.CONTRACT]: {
    color: GRAPH_CONTRACT_COLOR,
    type: 'column',
  },
  [graphColumns.MONTH]: {
    color: GRAPH_MONTH_COLOR,
    type: 'stackedColumn',
  },
  [graphColumns.QUARTER]: {
    color: GRAPH_QUARTER_COLOR,
    type: 'stackedColumn',
  },
  [graphColumns.ANNUAL]: {
    color: GRAPH_YEAR_COLOR,
    type: 'stackedColumn',
  },
  [graphColumns.TRADING]: {
    color: GRAPH_TRADING_COLOR,
    type: 'stackedColumn',
  },
  [graphColumns.RELEASING]: {
    color: GRAPH_RELEASING_COLOR,
    type: 'stackedColumn',
  },
  [graphColumns.RELEASE]: {
    color: GRAPH_RELEASED_COLOR,
    type: 'stackedColumn',
  },
};

export const createYAxis = (props) => {
  const { theme, hideYAxis, ...properties } = props;

  return {
    lineThickness: 0,
    tickLength: 0,
    gridThickness: 0,
    margin: 20,
    stripLines: !hideYAxis && [
      {
        value: 0,
        color: 'transparent',
        label: 'Dummy Long Label',
        labelMaxWidth: 30,
        labelPlacement: 'outside',
        labelBackgroundColor: 'transparent',
        labelFontColor: 'transparent',
      },
    ],
    labelFontFamily: theme.baseFontFamily,
    labelFontSize: theme.baseFontSize,
    labelFontColor: theme.baseFontColor,
    titleFontFamily: theme.baseFontFamily,
    titleFontSize: theme.baseFontSize,
    titleFontColor: theme.baseFontColor,
    ...properties,
  };
};

export const createXAxis = (props = {}) => {
  const { theme, ...properties } = props;
  return {
    ...properties,
    labelFontFamily: theme.baseFontFamily,
    labelFontSize: theme.baseFontSize,
    labelFontColor: theme.baseFontColor,
  };
};
